

























































































































// import
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  relationTypeQuery,
  relationQuery,
  relationTypeEdit,
  relationEdit,
  tagEdit,
  tagQuery,
  tagGroupEdit,
  tagGroupQuery,
  strategyTagEdit,
  strategyTagQuery
} from '@/api/strategyTag';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

const tagListOptions = [{ label: '', value: 1 }];

const tagGroupListOptions = [{ name: '', id: 1 }];

@Component({})
class StrategyTagDrawer extends Vue {
  @Prop()
  visible; // round

  @Prop()
  projectId;

  // projectId: number = 0;
  projectTagList: any[] = [];
  projectTagListShow: any[] = [];
  // visibleChild: boolean = false;
  tagListOptions: any[] = tagListOptions;
  tagGroupListOptions: any[] = tagGroupListOptions;
  value: any[] = [];
  tagGroupNowId: number = 1;
  tagGroupList: any[] = [];
  tagList: any[] = [];
  inputTag: string = '';
  inputTagGroup: string = '';
  showSelectList: boolean = false;
  relationVisible: boolean = false;

  formRelation: object = {
    relationId: '',
    tagOneName: '',
    // tagTwoName: '',
    tagOneId: [],
    tagTwoId: [],
    description: ''
  };

  rules: object = {
    relationId: [{ required: true, message: '请选择或新建标签关系!', trigger: 'blur' }],
    tagOneId: [{ required: true, message: '请选择标签!', trigger: 'blur' }],
    tagTwoId: [{ required: true, message: '请选择标签!', trigger: 'blur' }]
  };

  labelCol: object = { span: 4 };
  wrapperCol: object = { span: 14 };
  relationTypeList: any[] = [];

  optionsTagTwo: any[] = [];
  disableTagTwo: any[] = [];

  selectInput: string = '';

  mounted() {
    this.getProjectTag();
    this.getTagGroup(1);
  }

  // 抽屉
  afterVisibleChange(val) {
    console.log('visible', val);
    this.$emit('visible', val);
  }

  showDrawer() {
    this.$emit('visible', true);
  }

  onClose() {
    this.$emit('visible', false);
  }

  filterOption(input, option) {
    return option.componentOptions.children[0].text.indexOf(input) >= 0;
  }

  onChange(e, value) {
    console.log('e = ', e.target.checked);
    console.log('value = ', value);
    let type;
    if (e.target.checked === true) {
      type = 1;
    } else {
      type = 2;
    }
    this.editProjectTag(type, value);
  }

  openSelect() {
    this.showSelectList = true;
  }

  closeSelect(e) {
    console.log('e', e);
    this.showSelectList = false;
  }

  filterTag(key) {
    if (key === '') {
      this.tagListOptions = this.tagList.map(_ => {
        return { label: _.name, value: _.id };
      });
    } else {
      this.tagListOptions = this.tagList
        .map(_ => {
          return { label: _.name, value: _.id };
        })
        .filter(_ => _.label.match(key));
      if (this.tagListOptions.length === 0) {
      }
    }
  }

  filterTagGroup(key) {
    if (key === '') {
      this.tagGroupListOptions = this.tagGroupList.map(_ => {
        return { name: _.name, id: _.id };
      });
    } else {
      this.tagGroupListOptions = this.tagGroupList.filter(_ => _.name.match(key));
      console.log(this.tagGroupList, this.tagGroupListOptions);

      if (this.tagGroupListOptions.length === 0) {
      }
    }
  }

  selectTagGroup(id) {
    this.tagGroupNowId = id;
    this.getTag(this.tagGroupNowId);
  }

  changeProjectTagList(list) {
    let result: any = [];
    list.forEach(_ => {
      let tmp: any = result.find(e => e.groupId === _.groupId);
      if (tmp) {
        tmp.children.push({ id: _.id, name: _.name, num: _.useNum });
      } else {
        result.push({
          groupId: _.groupId,
          groupName: _.groupName,
          children: [{ id: _.id, name: _.name, num: _.useNum }]
        });
      }
    });
    return result;
  }

  async createRelation(tagOneId, tagOneName) {
    await this.getTagGroup(3);

    this.formRelation = {
      relationId: '',
      tagOneName: tagOneName,
      tagOneId: tagOneId,
      tagTwoId: [],
      description: ''
    };
    this.disableTagTwo = [];

    await this.getRelationType();
    this.formRelation['relationId'] = this.relationTypeList.length > 0 ? this.relationTypeList[0].id : '';

    this.setDisableList(tagOneId, this.disableTagTwo);

    this.relationVisible = true;
  }

  async setDisableList(value, disableList) {
    if (value.length === 2 && value[1]) {
      disableList.length = 0;
      disableList.push(value[1]);
      let res = await relationQuery({
        relationTypeId: this.formRelation['relationId']
      });
      if (res.code === 200) {
        res.data.list.forEach(_ => {
          // if(value.sort().toString() !== _.tagOneId.sort().toString() && ){
          if (value[1] === _.tagOne.id) {
            disableList.push(_.tagTwo.id);
            console.log('value+tagOneId', value, _.tagOne.id);
          } else if (value[1] === _.tagTwo.id) {
            disableList.push(_.tagOne.id);
          }
          // }
        });
        console.log(disableList);
      }
    }
  }

  submitRelationChange() {
    let tmp: any = this.$refs.ruleFormRelation;

    tmp.validate(valid => {
      if (valid) {
        this.relationEdit({
          description: this.formRelation['description'],
          relationId: this.formRelation['relationId'],
          tagOneId: this.formRelation['tagOneId'][1],
          tagTwoId: this.formRelation['tagTwoId'][1],
          type: 1
        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  cancelRelationChange() {
    let tmp: any = this.$refs.ruleFormRelation;
    setTimeout(() => {
      tmp.resetFields();
    }, 500);
  }

  async changeRelationType(e) {
    console.log('e', e);
    if (e === -1) {
      await relationTypeEdit({
        name: this.selectInput,
        type: 1
      });
      await this.getRelationType();
      let keyword = new RegExp(this.selectInput, 'g');
      this.formRelation['relationId'] = this.relationTypeList.find(_ => keyword.test(_.name)).id;
    } else {
      this.disableTagTwo = [];
      this.setDisableList(this.formRelation['tagOneId'], this.disableTagTwo);
    }
  }

  searchRelation(val) {
    this.selectInput = val;
    console.log('input', val);
    let keyword = new RegExp(val, 'g');
    if (this.relationTypeList.find(e => e.id === -1)) {
      this.relationTypeList.pop();
      this.formRelation['relationId'] = '';
    }
    if (this.relationTypeList.find(_ => keyword.test(_.name))) {
    } else {
      this.relationTypeList.push({ id: -1, name: '创建' + val });
    }
  }

  // TODO 加setDisable
  async loadDataTagTwo(selectedOptions) {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    // load options lazily
    try {
      console.log('loadDataTagTwo');

      let res = await tagQuery({
        groupId: targetOption.value
      });
      if (res.code === 200) {
        targetOption.loading = false;
        targetOption.children = res.data.list.map(_ => {
          let val = { value: _.id, label: _.name };
          if (this.disableTagTwo.indexOf(_.id) > -1) {
            val['disabled'] = true;
          }
          return val;
        });
        this.optionsTagTwo = [...this.optionsTagTwo];
      }
    } catch {}
  }

  async createTag(e) {
    if (e.keyCode !== 229 && this.tagListOptions.length === 0 && this.inputTag !== '') {
      let res = await tagEdit({ groupId: this.tagGroupNowId, name: this.inputTag, type: 1 });
      if (res.code === 200) {
        await this.getTag(this.tagGroupNowId);
        this.editProjectTag(1, this.tagListOptions[0].value);
      }
    }
  }

  async createTagGroup(e) {
    if (e.keyCode !== 229 && this.tagGroupListOptions.length === 0 && this.inputTagGroup !== '') {
      let res = await tagGroupEdit({ name: this.inputTagGroup, type: 1 });
      if (res.code === 200) {
        await this.getTagGroup(2);
      }
    }
  }

  async getTagGroup(type) {
    try {
      let res = await tagGroupQuery();
      if (res.code === 200) {
        this.tagGroupList = res.data.list;
        this.filterTagGroup(this.inputTagGroup);

        // 初始化
        if (type === 1) {
          this.selectTagGroup(this.tagGroupList[0].id);
          // 回车新建后选中
        } else if (type === 2) {
          this.selectTagGroup(this.tagGroupListOptions[0].id);
          // 选择标签关系里面初始化标签组
        } else if (type === 3) {
          this.optionsTagTwo = res.data.list.map(_ => {
            return { value: _.id, label: _.name, isLeaf: false };
          });
        }
        return true;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getTag(groupId) {
    try {
      let res = await tagQuery({
        groupId: groupId
      });
      if (res.code === 200) {
        this.tagList = res.data.list;
        this.filterTag(this.inputTag);
      } else {
        // this.$message.error(res.msg);
      }
      return true;
    } catch (err) {
      console.log(err);
    }
  }

  async editProjectTag(type, tagId) {
    try {
      console.log('type, tagId', type, tagId);

      let res = await strategyTagEdit({
        projectId: this.projectId,
        type,
        tagId
      });
      console.log(res);
      if (res.code === 200) {
        this.getProjectTag();
      }
    } catch {}
  }

  async getProjectTag() {
    try {
      let res = await strategyTagQuery({
        projectId: this.projectId
      });
      console.log(res);
      if (res.code === 200) {
        this.projectTagList = res.data.list;
        this.projectTagListShow = this.changeProjectTagList(this.projectTagList);
      }
    } catch {}
  }

  async relationEdit(body) {
    // 1.编辑/新增 2. 删除
    try {
      let res = await relationEdit(body);
      if (res.code === 200) {
        this.$message.success('添加成功');
        let tmp: any = this.$refs.ruleFormRelation;
        setTimeout(() => {
          tmp.resetFields();
        }, 500);
        this.relationVisible = false;
      } else {
        // this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getRelationType() {
    // 1 - init&refresh,选中第一条
    // 2 - refresh,选中不发生改变
    // 3 - refresh,选中最后一条的
    try {
      let res = await relationTypeQuery();
      if (res.code === 200) {
        this.relationTypeList = res.data.list;
      } else {
        // this.$message.error(res.msg);
      }
      return true;
    } catch (err) {
      console.log(err);
    }
  }
}

export default StrategyTagDrawer;
